// ============================================================================
// BUSINESS UNIT (BRANCH) ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/business-units';

export const businessUnitEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default businessUnitEndpoints;
